// pages/index.tsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import PageHeader from "../../../core/common/commonComponents/PageHeader";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";

// Map report labels to icons
const reportIcons: Record<string, string> = {
  "Employee Report": "bi-people",
  "Attendance Report": "bi-calendar-check",
  "Attendance Summary": "bi-calendar-range",
  "Leave Report": "bi-person-dash",
  "Leave Ledger": "bi-journal-text",
  "OnBoarding Report": "bi-person-plus",
  "OffBoarding Report": "bi-person-dash-fill",
  "Training Report": "bi-mortarboard",
  "Organization Skill Report": "bi-bar-chart-line",
  "Overtime Report": "bi-clock-history",
  "TimeSheet Report": "bi-stopwatch",
  "TimeSheetlog Report": "bi-journal-check",
  "Shift Report": "bi-journal-check",

  "Project Report": "bi-kanban",
  "Task Report": "bi-list-check",
  "Daily Report": "bi-calendar-day",

  "Payslip Report": "bi-receipt",
  "Salary Report": "bi-cash-stack",
  "Budget Report": "bi-wallet2",
  "Reimbursement Report": "bi-currency-exchange",
  "TDS Report": "bi-receipt",
  "PF Report": "bi-file-earmark-bar-graph",


  "User Report": "bi-person-badge",
  "Asset Allocation Report": "bi-box-arrow-right",
  "Asset Maintenance Report": "bi-tools",
};

const reportCategories = [
  {
    title: "HRM Reports",
    items: [
      { label: "Employee Report", link: all_routes.employeereport },
      { label: "Attendance Report", link: all_routes.attendancereport },
      { label: "Attendance Summary", link: all_routes.attendancesummary },
      { label: "Leave Report", link: all_routes.leavereport },
      { label: "Leave Ledger", link: all_routes.leaveledger },
      { label: "OnBoarding Report", link: all_routes.onboardingreport },
      { label: "OffBoarding Report", link: all_routes.offboardingreport },
      { label: "Training Report", link: all_routes.trainingreport },
      { label: "Organization Skill Report", link: all_routes.organizationskill },
      { label: "Overtime Report", link: all_routes.overtimereport },
      { label: "TimeSheet Report", link: all_routes.timesheetreport },
      { label: "TimeSheet log Report", link: all_routes.timesheetlogreport },
      { label: "Shift Report", link: all_routes.shift_report },
      { label: "Late login Report", link: all_routes.detail_report },
      { label: "Short Hours Report", link: all_routes.sort_report },
    ],
  },
  {
    title: "Project Reports",
    items: [
      { label: "Project Report", link: all_routes.projectreport },
      { label: "Task Report", link: all_routes.taskreport },
      { label: "Daily Report", link: all_routes.dailyreport },
    ],
  },
  {
    title: "Payroll & Accounts",
    items: [
      { label: "Payslip Report", link: all_routes.payslipreport },
      { label: "Salary Report", link: all_routes.salaryReport },
      { label: "Budget Report", link: all_routes.budgetreport },
      { label: "Reimbursement Report", link: all_routes.expensesreport },
      { label: "ESIC Report", link: all_routes.esic_report },
      { label: "TDS Report", link: all_routes.tds_report },
      { label: "PF Report", link: all_routes.pf_report },
    ],
  },
  {
    title: "Administration",
    items: [{ label: "User Report", link: all_routes.userreport }],
  },
  {
    title: "Asset Report",
    items: [
      { label: "Asset Allocation Report", link: all_routes.assestallocation },
      { label: "Asset Maintenance Report", link: all_routes.assetmaintenance },
    ],
  },
];

const ReportsDashboard: React.FC = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <PageHeader
            title="Reports Dashboard"
            breadcrumbs={[
              { label: <i className="ti ti-smart-home" />, path: all_routes.adminDashboard },
              { label: "Reports" },
              { label: "Reports Dashboard", isActive: true },
            ]}
            addLabel="Report Dashboard"
            rightExtra={<CollapseHeader />}
          />

          <div className="row">
            {/* Left Side - HRM Reports */}
            <div className="col-md-4">
              <div className="card shadow-sm border-0 rounded-3">
                <div
                  className="card-header bg-primary text-white fw-bold d-flex justify-content-between align-items-center"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-hrm"
                  style={{ cursor: "pointer" }}
                >
                  {reportCategories[0].title}
                  <i className="bi bi-chevron-down"></i>
                </div>
                <div id="collapse-hrm" className="collapse show">
                  <div className="card-body">
                    <ul className="list-unstyled mb-0">
                      {reportCategories[0].items.map((item) => (
                        <li key={item.label} className="mb-2">
                          <Link
                            to={item.link}
                            className="text-decoration-none d-flex align-items-center"
                          >
                            <i
                              className={`bi ${reportIcons[item.label] || "bi-file-earmark-text"} me-2 text-primary`}
                            ></i>
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Other Reports */}
            <div className="col-md-8 d-flex flex-column">
              <div className="row h-100 g-3">
                {reportCategories.slice(1).map((category, index) => (
                  <div className="col-6 d-flex" key={index}>
                    <div className="card flex-fill shadow-sm border-0 rounded-3">
                      <div
                        className="card-header bg-primary text-white fw-bold d-flex justify-content-between align-items-center"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${index}`}
                        style={{ cursor: "pointer" }}
                      >
                        {category.title}
                        <i className="bi bi-chevron-down"></i>
                      </div>
                      <div id={`collapse-${index}`} className="collapse show">
                        <div className="card-body">
                          <ul className="list-unstyled mb-0">
                            {category.items.map((item) => (
                              <li key={item.label} className="mb-2">
                                <Link
                                  to={item.link}
                                  className="text-decoration-none d-flex align-items-center"
                                >
                                  <i
                                    className={`bi ${reportIcons[item.label] || "bi-file-earmark-text"} me-2 text-primary`}
                                  ></i>
                                  {item.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default ReportsDashboard;
